<template>
  <div class="column is-2">
    <div class="folio-header-content">
      <div class="is-flex is-justify-content-center">
        <small class="pr-3">
          <strong>Folio {{ folio.id }}</strong>
        </small>
        <b-field v-if="estaAbierto">
          <b-checkbox
            :value="todosSeleccionados"
            :indeterminate="noTodosSeleccionados"
            @input="changeConfirmadoHandle"
          />
        </b-field>
      </div>
      <p class="linea-texto">
        <small> {{ folio.usuario.nombre }} </small>
      </p>
      <p class="linea-texto">
        <small>{{ folio.ubicacion }} - {{ fecha }}</small>
      </p>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

export default {
  name: 'ComparadorFolioHeader',
  props: {
    folio: {
      type: Object,
      required: true
    },
    estaAbierto: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      hover: false
    }
  },
  computed: {
    fecha() {
      return format(parseISO(this.folio.fecha), 'dd/MM HH:mm')
    },
    noTodosSeleccionados() {
      return this.folio.confirmados > 0 && this.folio.noConfirmados > 0
    },
    todosSeleccionados() {
      if (this.folio.confirmados > 0 && this.folio.noConfirmados === 0)
        return true
      return false
    }
  },
  methods: {
    changeConfirmadoHandle(val) {
      this.$store.dispatch('comparador/toggleFolioItem', {
        folioId: this.folio.id,
        articuloId: this.folio.items[0].articuloId,
        cantidad: this.folio.items[0].cantidad,
        valor: val,
        todos: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.column {
  padding: 0.5rem;
}
.b-tooltip {
  min-width: 100%;
}

.folio-header-content {
  border-radius: 5px;
  border: 1px solid #87a1a3;
  display: block;
  line-height: 1.5;
  padding: 0.2rem 0.8rem;
  text-align: center;

  &:hover {
    background-color: #f0f0f0;
    border: 1px solid black;
  }

  .linea-texto {
    text-overflow: ellipsis;
  }
}

.tooltip-content {
  z-index: 9999px;
}
</style>
